import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  fetchQuestionBrowseFacets,
  fetchQuestions,
  questionKeys,
  type QuestionBrowseScope,
  type QuestionListFilters,
} from './questionApi';

/** The scope's type/purpose pairs, concepts and taxonomy tree; the server caches them a minute too. */
export function useQuestionBrowseFacets(scope: QuestionBrowseScope) {
  return useQuery({
    queryKey: questionKeys.facets(scope),
    queryFn: () => fetchQuestionBrowseFacets(scope),
    staleTime: 60 * 1000,
  });
}

/** One page of the bank with the label, purpose and concept filters (the Question Bank page). */
export function useQuestionBrowsePage(params: QuestionListFilters) {
  return useQuery({
    queryKey: [...questionKeys.lists(), 'browse', params] as const,
    queryFn: () => fetchQuestions(params),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
}
